import { InlinePlusWidgetEnabledTopic } from "./consts";

const topics = {
  [InlinePlusWidgetEnabledTopic.ChinaEconomy]: [
    InlinePlusWidgetEnabledTopic.ChinaEconomy,
    InlinePlusWidgetEnabledTopic.ChinaTrade,
  ],
  [InlinePlusWidgetEnabledTopic.ChinaEURelations]: [
    InlinePlusWidgetEnabledTopic.ChinaEURelations,
    InlinePlusWidgetEnabledTopic.Diplomacy,
  ],
  [InlinePlusWidgetEnabledTopic.ChinaTechnology]: [
    InlinePlusWidgetEnabledTopic.USChinaTechWar,
    InlinePlusWidgetEnabledTopic.ChinaTechnology,
    InlinePlusWidgetEnabledTopic.ElectricNewEnergyVehicles,
  ],
  [InlinePlusWidgetEnabledTopic.ChinaTrade]: [
    InlinePlusWidgetEnabledTopic.ChinaEconomy,
    InlinePlusWidgetEnabledTopic.ChinaTrade,
  ],
  [InlinePlusWidgetEnabledTopic.Diplomacy]: [
    InlinePlusWidgetEnabledTopic.ChinaEURelations,
    InlinePlusWidgetEnabledTopic.Diplomacy,
    InlinePlusWidgetEnabledTopic.USChinaRelations,
  ],
  [InlinePlusWidgetEnabledTopic.ElectricNewEnergyVehicles]: [
    InlinePlusWidgetEnabledTopic.USChinaTechWar,
    InlinePlusWidgetEnabledTopic.ChinaTechnology,
    InlinePlusWidgetEnabledTopic.ElectricNewEnergyVehicles,
  ],
  [InlinePlusWidgetEnabledTopic.USChinaRelations]: [
    InlinePlusWidgetEnabledTopic.USChinaRelations,
    InlinePlusWidgetEnabledTopic.USChinaTradeWar,
  ],
  [InlinePlusWidgetEnabledTopic.USChinaTechWar]: [
    InlinePlusWidgetEnabledTopic.USChinaTechWar,
    InlinePlusWidgetEnabledTopic.ChinaTechnology,
    InlinePlusWidgetEnabledTopic.ElectricNewEnergyVehicles,
  ],
  [InlinePlusWidgetEnabledTopic.USChinaTradeWar]: [
    InlinePlusWidgetEnabledTopic.USChinaRelations,
    InlinePlusWidgetEnabledTopic.USChinaTradeWar,
  ],
};

export const getTopicsByTopicId = (topicId: string): string[] =>
  topics[topicId as keyof typeof topics] || [];
